// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.next {
  height: 130px;
  background-color: #2d62ed;
  width: 120px;
  border-radius: 15px;
}

.icon1 {
  width: 30px;
}

.carousel-content {
  color: white;
  background-color: #1f1d1b;
  max-height: 150px;
  border-radius: 15px;
  color: #676363;
  font-size: 1.3vw;
  width: 260px;
  line-height: 24px;
}

.controls {
  bottom: 14%;
  right: 10%;
  position: absolute;
  z-index: 20;
}

.title {
  top: 10px;
  right: 2px;
  font-size: 20px;
}

.sub {
  font-size: 10px;
}

/* .carouselimg {
  height: 875px;
} */

.carousel .carousel-item {
  height: auto;
}

.carouseltext {
  font-size: 3vw;
}
.text_container {
  height: 125vh !important;
}

@media only screen and (max-width: 768px) {
  .next {
    height: 55px;
    width: 60px;
    border-radius: 10px;
  }
  .icon1 {
    width: 25px;
  }
  .title {
    font-size: 8px;
  }

  .sub {
    font-size: 4px;
  }

  .controls {
    bottom: -7%;
    left: 13%;
  }

  .carouselimg {
    height: 350px;
  }

  .carouselvid {
    width: 350px;
    height: 30vh;
  }

  .carousel-content {
    height: 55px;
    font-size: 1vw;
    max-width: 10px;
  }

  .carousel .carousel-item {
    height: 350px;
  }
  .text_container {
    height: 350px !important;
  }
}

@media only screen and (max-width: 480px) {
  .controls {
    bottom: -7%;
    left: 10%;
  }
  .carousel .carousel-item {
    height: 650px;
  }
  .text_container {
    height: 650px !important;
  }
  .carouselimg {
    height: 220px;
  }
  /* .carousel-content {
    height: 55px;
    font-size: 2vw;
    max-width: 220px;
  } */
  .carouseltext {
    font-size: 5vw;
  }
  .carousel-content {
    height: 100px;
    font-size: 4vw;
    max-width: 220px;
  }

  .carousel-content p {
    margin-left: 5px;
    margin-top: 5px;
  }

  .next {
    height: 100px;
    width: 90px;
    border-radius: 10px;
  }
  .title {
    font-size: 4vw;
  }
  .sub {
    font-size: 2vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Homepage/Carousel/carousel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;;;;KAIG;EACH;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".next {\n  height: 130px;\n  background-color: #2d62ed;\n  width: 120px;\n  border-radius: 15px;\n}\n\n.icon1 {\n  width: 30px;\n}\n\n.carousel-content {\n  color: white;\n  background-color: #1f1d1b;\n  max-height: 150px;\n  border-radius: 15px;\n  color: #676363;\n  font-size: 1.3vw;\n  width: 260px;\n  line-height: 24px;\n}\n\n.controls {\n  bottom: 14%;\n  right: 10%;\n  position: absolute;\n  z-index: 20;\n}\n\n.title {\n  top: 10px;\n  right: 2px;\n  font-size: 20px;\n}\n\n.sub {\n  font-size: 10px;\n}\n\n/* .carouselimg {\n  height: 875px;\n} */\n\n.carousel .carousel-item {\n  height: auto;\n}\n\n.carouseltext {\n  font-size: 3vw;\n}\n.text_container {\n  height: 125vh !important;\n}\n\n@media only screen and (max-width: 768px) {\n  .next {\n    height: 55px;\n    width: 60px;\n    border-radius: 10px;\n  }\n  .icon1 {\n    width: 25px;\n  }\n  .title {\n    font-size: 8px;\n  }\n\n  .sub {\n    font-size: 4px;\n  }\n\n  .controls {\n    bottom: -7%;\n    left: 13%;\n  }\n\n  .carouselimg {\n    height: 350px;\n  }\n\n  .carouselvid {\n    width: 350px;\n    height: 30vh;\n  }\n\n  .carousel-content {\n    height: 55px;\n    font-size: 1vw;\n    max-width: 10px;\n  }\n\n  .carousel .carousel-item {\n    height: 350px;\n  }\n  .text_container {\n    height: 350px !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .controls {\n    bottom: -7%;\n    left: 10%;\n  }\n  .carousel .carousel-item {\n    height: 650px;\n  }\n  .text_container {\n    height: 650px !important;\n  }\n  .carouselimg {\n    height: 220px;\n  }\n  /* .carousel-content {\n    height: 55px;\n    font-size: 2vw;\n    max-width: 220px;\n  } */\n  .carouseltext {\n    font-size: 5vw;\n  }\n  .carousel-content {\n    height: 100px;\n    font-size: 4vw;\n    max-width: 220px;\n  }\n\n  .carousel-content p {\n    margin-left: 5px;\n    margin-top: 5px;\n  }\n\n  .next {\n    height: 100px;\n    width: 90px;\n    border-radius: 10px;\n  }\n  .title {\n    font-size: 4vw;\n  }\n  .sub {\n    font-size: 2vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
